export const roundHalf = (num: number, roundDown = false): number => {
  if (roundDown) {
    return Math.floor(num * 2) / 2;
  }

  return Math.round(num * 2) / 2;
};
